// extracted by mini-css-extract-plugin
export var grid = "G_J";
export var hex = "G_V";
export var img = "G_B";
export var imgRight = "G_0";
export var txt = "G_s";
export var wrapper = "G_1";